import { createApp } from 'vue'
import Welcome  from './components/Welcome'
import informe21  from './components/informe21'
import Tareas   from './components/Tareas'
import Padron   from './components/padron'
const app = createApp({})
app.component('welcome', Welcome)
app.component('informe21', informe21)
app.component('tareas', Tareas)
app.component('padron', Padron)
app.mount('#app')
